var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"private-network"},[_c('p',{staticClass:"df fdc aic"},[_c('img',{attrs:{"src":require("@/assets/img/no_premise.png"),"alt":"专网公文","width":"280"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tips))])]),_vm._v(" "),_c('p',{staticClass:"private-network__address"},[_vm._v(_vm._s(_vm.PRIVATE_DOMAIN_NAME))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb2c616a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrivateNetwork/index.vue
// module id = null
// module chunks = 